module.exports = __webpack_public_path__ + "img/X@2x.9565650.jpg";